import { Title, Wrapper } from "./styles";
import { Accordion } from "../../landing-components/Accordion";
import { ToggleList } from "../../landing-components/ToggleList";
import { StyledButton } from "../generic";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
export const FAQ = () => {
  const { t, i18n } = useTranslation("home");
  const location = useLocation();

  const pageKey = location.pathname.includes("hospita")
    ? "host"
    : location.pathname.includes("students")
    ? "student"
    : "home";

  const studentQuestions = new Array(6).fill("").map((_, i) => ({
    title: t(`faq.student.p${i + 1}.title`),
    content: t(`faq.student.p${i + 1}.content`)
  }));
  const hostQuestions = new Array(7).fill("").map((_, i) => ({
    title: t(`faq.host.p${i + 1}.title`),
    content: t(`faq.host.p${i + 1}.content`)
  }));

  const sharedQuestions = pageKey === "host" ? hostQuestions : studentQuestions;

  const hostAccordion = <Accordion questions={hostQuestions} />;
  const studentAccordion = <Accordion questions={studentQuestions} />;

  return (
    <Wrapper>
      <Title>
        {t("faq.title.p1")} <span>{t("faq.title.p2")}</span>
      </Title>
      {pageKey === "home" ? (
        <ToggleList
          titles={[t("forHosts"), t("forStudents")]}
          content={[hostAccordion, studentAccordion]}
        />
      ) : (
        <div>
          <Accordion questions={sharedQuestions} />
        </div>
      )}

      <div style={{ margin: "0 auto" }}>
        <NavLink to={`/${i18n.language}/faq`}>
          <StyledButton outline={true} p="16px 32px">
            {t("buttons.allFaq")}
          </StyledButton>
        </NavLink>
      </div>
    </Wrapper>
  );
};
